// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"dd31006766--tooltip--gA5q6","arrow_tooltip":"dd31006766--arrow_tooltip--HT0YK","arrow":"dd31006766--arrow--nMIiS"};